export default {
  solicitacoes: [],
  solicitacoesPrimeiroCarregamento: [],
  arquivos: [],
  reasonsSabesp: [],
  groupedSolicitations: [
    { status: 'Em andamento', total: 0 },
    { status: 'Concluído', total: 0 },
    { status: 'Cancelado', total: 0 }
  ],
  groupedSolicitationsStatus: [],
  modalAddMsgSolicitationInfo: '',
  overlap: {
    display: false,
    label: ''
  },
  activeProtocol: {
    protocolo: null,
    tipoServico: null
  },
  solicitationToView: {},
  modalAlterHistoricoData: {},
  alterCancelPermission: false,
  alterCancelChanges: []
}
